import { render, staticRenderFns } from "./learningchart.vue?vue&type=template&id=04767f7f&scoped=true"
import script from "./learningchart.vue?vue&type=script&lang=js"
export * from "./learningchart.vue?vue&type=script&lang=js"
import style0 from "./learningchart.vue?vue&type=style&index=0&id=04767f7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04767f7f",
  null
  
)

export default component.exports